import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ReactComponent as MenuIconWhite } from '../../../../assets/icons/MenuDots.svg';
import { ReactComponent as MenuIconBlack } from '../../../../assets/icons/MenuDotsB.svg';
import { ReactComponent as ListIcon } from '../../../../assets/icons/list.svg';
import { ConditionWithDetails, getFbsConditionLabel } from '../../../../api/conditions';
import './ConditionsTable.scss';

type Props = {
  conditionData: ConditionWithDetails;
  onViewCondition: (condition: ConditionWithDetails) => void;
  onEditCondition: (condition: ConditionWithDetails) => void;
  onDeleteCondition: (conditionId: number) => void;
};

const ConditionsTableRow: React.FC<Props> = ({ conditionData, onViewCondition, onEditCondition, onDeleteCondition }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const onOptionClick = (action: string) => {
    if (action === 'view') {
      onViewCondition(conditionData);
    } else if (action === 'edit') {
      onEditCondition(conditionData);
    } else if (action === 'delete') {
      onDeleteCondition(conditionData.id);
    }
    setIsMenuOpen(false);
  };

  const actionMenuStyles = {
    backgroundColor: isMenuOpen ? '#238698' : 'transparent',
  };

  const onMenuIconClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className='table-row'>
      <div className='table-cell condition-name'>
        {conditionData.name ? conditionData.name : '-'}
      </div>
      <div className='table-cell'>
        {conditionData.body_systems && conditionData.body_systems.length > 0
          ? conditionData.body_systems.map(bs => bs.title).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell description'>
        {conditionData.description ? conditionData.description : '-'}
      </div>
      <div className='table-cell biomarkers'>
        {conditionData.biomarkers && conditionData.biomarkers.length > 0
          ? conditionData.biomarkers.map(bm => bm.name).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell fbs-conditions'>
        {conditionData.mri_conditions && conditionData.mri_conditions.length > 0
          ? conditionData.mri_conditions.map(mc => getFbsConditionLabel(mc)).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell actions'>
        <OutsideClickHandler onOutsideClick={() => setIsMenuOpen(false)}>
          <div className='action-menu-container'>
            <div className='menu-btn' style={actionMenuStyles}>
              {isMenuOpen ? (
                <MenuIconWhite onClick={(e) => onMenuIconClick(e)} />
              ) : (
                <MenuIconBlack onClick={(e) => onMenuIconClick(e)} />
              )}
            </div>
            {isMenuOpen && (
              <div className='action-menu'>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOptionClick('view');
                  }}
                  className='option'
                >
                  <ListIcon />
                  View/Edit
                </div>
              </div>
            )}
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default ConditionsTableRow;
